import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/home/index'
import About from '../views/about/index'
import AboutProfile from '../views/about/profile'
import AboutReveal from '../views/about/reveal'
import AboutEvent from '../views/about/event'
import AboutOrg from '../views/about/org'
import AboutParty from '../views/about/party'
import AboutPartd from '../views/about/partd'
import AboutInfo from '../views/about/info'

import Project from '../views/pros/index'
import proDetail from '../views/pros/detail'
import New from '../views/news/index'
import newDetail from '../views/news/detail'
import Volunt from '../views/volunt/index'
import VoluntDetail from '../views/volunt/detail'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },

    {
      path: '/about',
      name: 'About',
      component: About,
      children: [
        {
          path: '/about/profile',
          name: 'AboutProfile',
          component: AboutProfile,
        },
        {
          path: '/about/reveal',
          name: 'AboutReveal',
          component: AboutReveal,
        },
        {
          path: '/about/event',
          name: 'AboutEvent',
          component: AboutEvent,
        },
        {
          path: '/about/org',
          name: 'AboutOrg',
          component: AboutOrg,
        },
        {
          path: '/about/party',
          name: 'AboutParty',
          component: AboutParty,
        },
        {
          path: '/about/info',
          name: 'AboutInfo',
          component: AboutInfo,
        },
      ]
    },
    {
      path: '/about/partd/:id',
      name: 'AboutPartd',
      component: AboutPartd,
    },
    {
      path: '/pro',
      name: 'Project',
      component: Project
    },
    {
      path: '/prod/:id',
      name: 'proDetail',
      component: proDetail
    },

    {
      path: '/new',
      name: 'New',
      component: New
    },
    {
      path: '/newd/:id',
      name: 'newDetail',
      component: newDetail
    },

    {
      path: '/vol',
      name: 'Volunt',
      component: Volunt
    },
    {
      path: '/vol/:id',
      name: 'VoluntDetail',
      component: VoluntDetail
    }
  ]
})
